import { ObjectField, NoPointers, Field, Int32Field, BooleanField, } from "@opendaw/lib-box";
import { Pointers } from "@opendaw/studio-enums";
export class SignatureTrack extends ObjectField {
    static create(construct) {
        return new SignatureTrack(construct);
    }
    constructor(construct) {
        super(construct);
    }
    get events() {
        return this.getField(1);
    }
    get index() {
        return this.getField(10);
    }
    get enabled() {
        return this.getField(20);
    }
    initializeFields() {
        return {
            1: Field.hook({
                parent: this,
                fieldKey: 1,
                fieldName: "events",
                deprecated: false,
                pointerRules: {
                    accepts: [Pointers.SignatureAutomation],
                    mandatory: false,
                    exclusive: false,
                },
            }),
            10: Int32Field.create({
                parent: this,
                fieldKey: 10,
                fieldName: "index",
                deprecated: false,
                pointerRules: NoPointers,
            }, "index", "", 1),
            20: BooleanField.create({
                parent: this,
                fieldKey: 20,
                fieldName: "enabled",
                deprecated: false,
                pointerRules: NoPointers,
            }, true),
        };
    }
}
